import Container from "@mui/material/Container";
import MagentoOrdersTable from "./MagentoOrdersTable";

function MagentoOrdersTab() {
  return (
    <div>
      <Container maxWidth={false} sx={{ my: 3 }}>
        <MagentoOrdersTable />
      </Container>
    </div>
  );
}

export default MagentoOrdersTab;
